/**
 * Pricing tiers for company size-based subscriptions.
 * Mirrors backend/config/pricing.php
 *
 * Prices are in CHF (Swiss Francs)
 */
export const PRICING_TIERS = {
	'1-20': {
		key: '1-20',
		label: '1-20 employees',
		monthly: 230,
		annual: 2300
	},
	'21-50': {
		key: '21-50',
		label: '21-50 employees',
		monthly: 450,
		annual: 4500
	},
	'51-100': {
		key: '51-100',
		label: '51-100 employees',
		monthly: 750,
		annual: 7500
	},
	'101-250': {
		key: '101-250',
		label: '101-250 employees',
		monthly: 950,
		annual: 9500
	},
	'251-500': {
		key: '251-500',
		label: '251-500 employees',
		monthly: 1450,
		annual: 14500
	}
}

/**
 * Get tier keys as an ordered array
 */
export const TIER_KEYS = ['1-20', '21-50', '51-100', '101-250', '251-500']

/**
 * Calculate yearly savings for a tier
 * @param {string} tierKey - The tier key (e.g., '21-50')
 * @returns {number} Savings in CHF
 */
export function calculateSavings(tierKey) {
	const tier = PRICING_TIERS[tierKey]
	if (!tier) return 0
	return (tier.monthly * 12) - tier.annual
}

/**
 * Get monthly equivalent price for yearly billing
 * @param {string} tierKey - The tier key
 * @returns {number} Monthly equivalent in CHF
 */
export function getMonthlyEquivalent(tierKey) {
	const tier = PRICING_TIERS[tierKey]
	if (!tier) return 0
	return Math.round(tier.annual / 12)
}
